import { Button } from 'primereact/button';

import { Incident } from '../../domain/incident.model';

type IncidentActionsSectionProps = {
  isSentToColumbus: boolean;
  isSending: boolean;
  sendToColumbus: () => Promise<void>;
  sendEmail: (plainText: string, file?: File | null) => void;
  plainText: string;
  file: File | null;
  t: (key: string) => string;
  localIncident: Incident;
};

export const IncidentActionsSection = ({
  isSentToColumbus,
  isSending,
  sendToColumbus,
  sendEmail,
  plainText,
  file,
  t,
  localIncident,
}: IncidentActionsSectionProps) => (
  <div style={{ display: 'flex', gap: '1rem', marginTop: '2rem' }}>
    {!isSentToColumbus && (
      <Button
        label={t('otherIncidentManagement.incidentDetail.bottomMenu.sendColumbus')}
        className="p-button-success"
        loading={isSending}
        onClick={sendToColumbus}
      />
    )}

    {isSentToColumbus && (
      <a
        href={localIncident.linkColumbus}
        target="_blank"
        rel="noopener noreferrer"
        className="p-button p-button-success"
      >
        {t('otherIncidentManagement.incidentDetail.bottomMenu.goColumbus')}
      </a>
    )}

    <Button
      label={t('otherIncidentManagement.incidentDetail.bottomMenu.sendEmail')}
      className="p-button-info"
      loading={isSending}
      onClick={() => sendEmail(plainText, file)}
    />
  </div>
);
